import { Injectable } from '@angular/core';
import {
  BADSTOCKCART,
  AdpCustomer,
  attributesMap,
  attributesPropertiesMap,
  STOCKCART,
  MOVESTOCKLOCATION,
  loggedInUser
} from '../providers/data';
import { CartPage } from '../pages/cart/cart';
import { Headers, RequestOptions } from '@angular/http';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
import { CustomerCarts } from './user-cart-provider/user-carts';
import moment from "moment";
@Injectable()
export class BadstockcartManager {



  public getCust:any ;
  constructor(private storage:Storage,private sanitizer:DomSanitizer){

  }



  setCustomer(customer){

    if(BADSTOCKCART.customer == null){

      BADSTOCKCART.customer = customer;
    }else{
      this.clearCartProducts();
      BADSTOCKCART.customer = customer;
    }
    //alert(JSON.stringify(BADSTOCKCART));
  }

  // setSalesPerson(user){
  //   BADSTOCKCART.user = user;
  //   //alert(JSON.stringify(BADSTOCKCART));
  // }


  // placeOrder(){
  // }

  clearCart(){
    BADSTOCKCART.items = [];
  }


  addToCartNew(product) {
    if(!Number(product.quantity)){
      product.quantity = 0;
    }

    BADSTOCKCART.items.push(product);
    this.persistOrderLocal();
  }
  addProductToCart(product) {
    var index= BADSTOCKCART.items.map(function(x) {return x.productLocationIdWithCode; }).indexOf(product.productLocationIdWithCode);
    if (index != -1) {
      BADSTOCKCART.items[index].quantity++;
      this.persistOrderLocal();
    } else {
      if (Number(product.quantity) != 0) {
        product.quantity = Number(product.quantity);
      } else {
        product.quantity = 0;
      }
      this.addToCartNew(product);
    }
  }

  // addProductToCartPopup(product) {
  //   product.quantity++;
  //   this.persistOrderLocal();
  //
  //   if (Number(product.quantity) != 0) {
  //     product.quantity = Number(product.quantity);
  //   } else {
  //     product.quantity = 0;
  //   }
  //
  // }

  // update Cart
  updateCartNew(product) {



    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }

      }

    }


    var index= BADSTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      //BADSTOCKCART.items[index].quantity++;
    } else {

      this.addToCartNew(product);
    }
    this.persistOrderLocal();
    //alert(JSON.stringify(BADSTOCKCART));
  }

  updateCartNewPopup(product) {


    if(Number(product.quantity) < Number(product.minOrder)){
      if (Number(product.minOrder) != 0) {
        if (Number(product.quantity) != 0) {
          product.quantity = Number(product.quantity);
        }

      }

    }


    var index= BADSTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      //BADSTOCKCART.items[index].quantity++;
    } else {

      // this.addToCartNew(product);
    }
    this.persistOrderLocal();
    //alert(JSON.stringify(BADSTOCKCART));
  }
  // Remove One
  removeOneNew(product) {
    product.quantity--;

  }

  // removeOneNewPopup(product) {
  //   var index= BADSTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
  //   if (index != -1) {
  //     BADSTOCKCART.items[index].quantity--;
  //     this.persistOrderLocal();
  //
  //   }
  // }

  // Remove All
  removeAll(product) {
    var index= BADSTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      if(BADSTOCKCART.items[index].quantity >= 1){
        BADSTOCKCART.items[index].quantity = 0;
      }
    }
    this.persistOrderLocal();
  }


  // Remove Item
  removeNew(index: number): void {

    BADSTOCKCART.items.splice(index, 1);
    this.persistOrderLocal();
  }

  deleteProductFromCart(product){
    this.removeAll(product);
    var index= BADSTOCKCART.items.map(function(x) {return x.productLocationIdWithCode; }).indexOf(product.productLocationIdWithCode);
    if (index != -1) {
      this.removeNew(index);
    }
  }

  genrateOrder(status){
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = BADSTOCKCART.shipDate;
    for(let item of BADSTOCKCART.items){

      if(this.discountCheck(item.discountPrice)){
        total =  total + (Number(item.discountPrice) * Number(item.quantity));
      }else{
        total =  total + (Number(item.price) * Number(item.quantity));
      }

      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch
      };


      orderProducts.push(orderDetailDTOs);
    }

    if(BADSTOCKCART.customer.locationsDTOs.length>0){
      for(let locationId in BADSTOCKCART.customer.locationsDTO){
        BADSTOCKCART.customer.locationsDTO[locationId].createdAt = "";
        BADSTOCKCART.customer.locationsDTO[locationId].updatedAt = "";
      }
    }

    BADSTOCKCART.customer.customerJson = "";

    let order = {
      "id":BADSTOCKCART.orderId,
      "orderTitle": this.getOrderTitle(),
      "salesManId":BADSTOCKCART.user.id,
      "orderMessage":BADSTOCKCART.orderMessage,
      "expectedShipmentDate": BADSTOCKCART.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":BADSTOCKCART.customer,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":BADSTOCKCART.shippingServiceName,
      "shippingServiceValue":BADSTOCKCART.shippingServiceId
    };
    //this.gVLogger.log(JSON.stringify(order));

    return order;

  }

  setLocation(location){
    MOVESTOCKLOCATION.productsLocation = location;
  }

  receiveStock(status, reference, productLocation){
    //alert(JSON.stringify(BADSTOCKCART));
    // let total = 0;
    // let orderProducts = [];
    // let expectedShipmentDate = BADSTOCKCART.shipDate;


    const date = moment().format("YYYY-MM-DD");

    // setTimeout(() => {
      var productsDTOList = [];
      for(let item of BADSTOCKCART.items){

        for(let badPro of item.productInventoryLocationsDTO){
          let commentLine = "";

          if(badPro.comment !== null && badPro.comment !== ""){

            badPro.productComments = btoa(loggedInUser.userName + "(" +  date +")" + ": " + badPro.comment);
            console.log("UUUUUUUUUUUUU : " + badPro.productComments)

          }
        }



        productsDTOList.push(item);

        // if(this.discountCheck(item.discountPrice)){
        //   total =  total + (Number(item.discountPrice) * Number(item.quantity));
        // }else{
        //   total =  total + (Number(item.price) * Number(item.quantity));
        // }
        //
        // item.quantity = item.quantity;
        //
        // item.referenceNumber = reference;
        // item.locationCode = productLocation;



        // orderProducts.push(orderDetailDTOs);
      }


      // BADSTOCKCART.customer.customerJson = "";


      let order = {
        // "id":BADSTOCKCART.orderId,
        // "barCode":BADSTOCKCART.orderId,
        // "orderTitle": this.getOrderTitle(),
        // "salesManId":BADSTOCKCART.user.id,
        // "orderMessage":BADSTOCKCART.orderMessage,
        // "expectedShipmentDate": BADSTOCKCART.expectedShipmentDate,
        // "totalAmount":""+total.toFixed(2),
        // "totalTexAmount":"10",
        // "orderStatus":status,
        // "customerDTO":BADSTOCKCART.customer,
        "productsDTO": productsDTOList,
        // "shippingServiceName":BADSTOCKCART.shippingServiceName,
        // "shippingServiceValue":BADSTOCKCART.shippingServiceId
      };
      //this.gVLogger.log(JSON.stringify(order));

      return productsDTOList;
    // },500)





  }

  clearCartProducts(){
    for(let product of BADSTOCKCART.items){
      this.removeAll(product);
    }
    BADSTOCKCART.items = [];
  }

  getProductsCount(){
    return BADSTOCKCART.items.length;
  }

  getSalesManId(){
    return BADSTOCKCART.user.id;
  }
  getCustomerName(){
    if(BADSTOCKCART.customer !=null){

      return BADSTOCKCART.customer.name;
    }else{
      return null;
    }
  }

  getSalesPerson(){
    return BADSTOCKCART.user;

  }

  getADPCustomerUUID(){
    if(BADSTOCKCART.user && BADSTOCKCART.user.adpCustomerInfo){
      return BADSTOCKCART.user.adpCustomerInfo.uuid;
    }else{
      return "";
    }
  }

  setShipDate(shipDate){
    BADSTOCKCART.expectedShipmentDate = shipDate ;
  }
  // getShipDate(){
  //   return BADSTOCKCART.expectedShipmentDate;
  // }

  // setOdId(odId){
  //   BADSTOCKCART.odId = odId;
  // }

  // getOdId(){
  //   return BADSTOCKCART.odId;
  // }

  // setItems(productsList){
  //   BADSTOCKCART.items = productsList;
  // }
  setOrderId(orderId){
    BADSTOCKCART.orderId = orderId ;
  }
  setOrderMessage(orderMessage){
    BADSTOCKCART.orderMessage = orderMessage;
  }
  // getOrderMessage(){
  //   return BADSTOCKCART.orderMessage;
  // }
  //
  // getExpectedSipDate(){
  //   return BADSTOCKCART.expectedSipDate;
  // }

  getItems(){
    return BADSTOCKCART.items;
  }


  getCustomerID(){
    if(BADSTOCKCART.customer!=null){
      return BADSTOCKCART.customer.id;
    }else{
      return false;
    }
  }


  // getSelectedCustomer(){
  //   return BADSTOCKCART.customer;
  // }

  setOrderTitle(orderTitle){
    BADSTOCKCART.orderTitle = orderTitle;
  }

  getOrderTitle(){
    return BADSTOCKCART.orderTitle;
  }
  getOrderId(){
    return BADSTOCKCART.orderId;
  }

  persistOrderLocal(){
    // TODO: Store the list of Cart against their user/sales persons
    let itemQuantityStatus = false;
    for(let product of BADSTOCKCART.items){
      if(product.quantity > 0){
        itemQuantityStatus = true;
        break;
      }
    }

    if(Number(BADSTOCKCART.items.length) > 0 && itemQuantityStatus){
      this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),BADSTOCKCART);

    }else{
      this.unPersistOrderLocal();
    }
//this.gVLogger.log(BADSTOCKCART);
  }
  unPersistOrderLocal(){
    this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  }

  // getPersistedOrderLocal(){
  //
  //   return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
  // }

  // setCartFull(cartTemp){
  //   BADSTOCKCART.items = cartTemp.items;
  //   BADSTOCKCART.orderId = cartTemp.orderId;
  //   BADSTOCKCART.orderMessage = cartTemp.orderMessage;
  //   BADSTOCKCART.customer = cartTemp.customer;
  //   BADSTOCKCART.orderTitle = cartTemp.orderTitle;
  //   // this.gVLogger.log("Cart Replaced...",cartTemp);
  // }


  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }

  getOrderStatus(){
    return BADSTOCKCART.orderStatus;
  }

  setOrderStatus(status){
    BADSTOCKCART.orderStatus = status;
  }


  // removeJunkFromCart(){
  //   for(let item of BADSTOCKCART.items ){
  //     // this.gVLogger.log("Item: ",item);
  //     if(item.quantity == 0 || item.quantity == '0'){
  //       // this.gVLogger.log("Item inner: ",item);
  //       var index= BADSTOCKCART.items.map(function(x) {return x.id; }).indexOf(item.id);
  //       if (index != -1) {
  //         if(BADSTOCKCART.items[index].quantity >= 1){
  //           BADSTOCKCART.items[index].quantity = 0;
  //         }
  //         BADSTOCKCART.items.splice(index, 1);
  //       }
  //     }
  //   }
  // }


  makeImageURL(dimensions,item){
    return  IMAGES_BASE_URL.imageBaseUrl + "/" + this.getADPCustomerUUID() +
      "/products/" +
      dimensions + "/"+
      item.productImagesDTO[0].name+
      "-" +
      dimensions +
      "." +
      item.productImagesDTO[0].extension;
  }

  getAdpCustomerInfo(){
    return AdpCustomer.AdpCustomerInfo;
  }


  // sanitizeUrl(url){
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }



  // addToAttributeMap(key,value){
  //   attributesMap[key+""] = ""+value;
  // }

  getAttributeValue(key){
    let res = attributesMap[key+""];
    if(res === undefined){
      return "-"
    }else{
      return res;
    }
  }


  // addAttributePropertiesMap(key,val){
  //   attributesPropertiesMap.set(key+"", val);
  // }
  //
  // getAllAttributesPropertiesMap(){
  //   return attributesPropertiesMap;
  // }

  replaceDoublePipe(str){
    return str.split("||").join(" ");
  }

  ConvertToCSV(objArray) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = "";
    for (let index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line != '') line += ',';
        line += array[i][index];
      }
      str += line + '\r\n';
    }
    return str;
  }

  setReference(data) {

  }
}



// WEBPACK FOOTER //
// ./src/providers/badstockcart-manager.ts